import React from "react";
import Navbar from "./navbar";
import ServiceHeroSection from "./ServiceHeroSection";
import Footer from "./Footer";
import StatsCounter from "./StatsCounter";
import WorkProcess from "./WorkProcess";
import TechStack from "./TechStack";
import WhyChooseUsAi from "./WhyChooseUsAi";
import AiServices from "./AiServices";
import ProcessSection from "./ProcessSection";
import CallToAction from "./CallToAction";
import aiImage from "../Images/aiservice.png";

export default function AIServicePage() {
  return (
    <div className="min-h-screen bg-white overflow-x-clip">
      <Navbar />
      <ServiceHeroSection
        badge="AI Services"
        title={(
          <>
            <span className="bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
              Custom AI Solutions
            </span>
            <br /> for Modern Businesses
          </>
        )}
        description="We design and build AI-powered applications, intelligent automation, and custom workflows that streamline operations, boost productivity, and deliver measurable business results."
        media={(
          <div className="relative flex justify-center w-full lg:-ml-12 lg:-mt-4 z-10 pointer-events-none">
            {/* Background Glow */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-96 h-96 rounded-full bg-indigo-500/20 blur-[100px]" />
            </div>

            {/* Overlapping AI Image */}
            <img
              src={aiImage}
              alt="AI development illustration"
              className="relative z-10 w-full max-w-[580px] object-cover mix-blend-screen scale-110"
              style={{
                maskImage: 'radial-gradient(circle at center, black 50%, transparent 82%)',
                WebkitMaskImage: 'radial-gradient(circle at center, black 50%, transparent 82%)',
              }}
            />
          </div>
        )}
      />
      <StatsCounter />
      <WhyChooseUsAi />
      <WorkProcess />
      <TechStack />
      <AiServices />
      <ProcessSection />
      <CallToAction />
      <Footer />
    </div>
  );
}
